export default __webpack_public_path__ + "static/media/Mask Group 193@3x.602b95c7.png";